"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _ActiveHubSelectors = require("pricing-pages-unified-ui/selectors/ActiveHubSelectors");

var _EditionSelectionButtonGroup = _interopRequireDefault(require("../common/EditionSelectionButtonGroup"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _ProductOwnershipSelectors = require("pricing-pages-unified-ui/selectors/ProductOwnershipSelectors");

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _MerchandiseSelectors2 = require("../../selectors/MerchandiseSelectors");

var _highestEdition = require("pricing-pages-unified-ui/utils/highestEdition");

var _Editions = require("self-service-api/constants/Editions");

var HubCalcEditionSelectionContainer = function HubCalcEditionSelectionContainer(_ref) {
  var highestOwnedEdition = _ref.highestOwnedEdition,
      activeHub = _ref.activeHub,
      activeCurrencyCode = _ref.activeCurrencyCode,
      activeEdition = _ref.activeEdition,
      setActiveEdition = _ref.setActiveEdition,
      getMerchIdForEdition = _ref.getMerchIdForEdition,
      products = _ref.products;

  /* don't want to update the active merch to a free active merch because this will reconfigure
  additionalCostPerUnit and other functions that a free merch id does not support  */
  (0, _react.useEffect)(function () {
    setActiveEdition((0, _highestEdition.highestEdition)(highestOwnedEdition, activeEdition, _Editions.STARTER));
  }, [activeHub]);

  var handleEditionUpdated = function handleEditionUpdated(edition) {
    setActiveEdition(edition);
    var merchId = getMerchIdForEdition(activeHub, edition);
    (0, _getUsageTracker.default)().track('clickMerchSelectionButton', {
      merchandise: products[merchId].trackingName,
      currency: activeCurrencyCode
    });
  };

  return _react.default.createElement(_EditionSelectionButtonGroup.default, {
    activeEdition: activeEdition,
    onEditionUpdated: handleEditionUpdated,
    ownedEdition: highestOwnedEdition
  });
};

HubCalcEditionSelectionContainer.propTypes = {
  activeHub: _propTypes.default.oneOf(Object.values(_Hubs.default || {})),
  highestOwnedEdition: _propTypes.default.string.isRequired,
  activeCurrencyCode: _propTypes.default.string.isRequired,
  activeEdition: _propTypes.default.string.isRequired,
  setActiveEdition: _propTypes.default.func.isRequired,
  getMerchIdForEdition: _propTypes.default.func.isRequired,
  products: _propTypes.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var activeHub = (0, _ActiveHubSelectors.activeHubSelector)(state);
  return {
    activeHub: activeHub,
    highestOwnedEdition: (0, _ProductOwnershipSelectors.highestOwnedEditionInHubSelector)(state, activeHub),
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    getMerchIdForEdition: (0, _MerchandiseSelectors2.getMerchIdForEditionSelector)(state),
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(HubCalcEditionSelectionContainer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/HubCalcEditionSelectionContainer.js
// module id = 802
// module chunks = 5 6